import { LocalNotifications } from '@capacitor/local-notifications';
import { PermitActions } from '../../Reducer/PermitReducer';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { WorkingCheckActions } from '../../Reducer/WorkingCheckReducer';

// 작업허가서 알림 처리
export const handlePermitNotification = (dispatch, body) => {
  if (body === '작업허가서 반려 안내') {
    dispatch(PermitActions.setPermitAlarm('반려'));
  } else if (body === '작업 허가서 요청입니다.') {
    dispatch(PermitActions.setPermitAlarm('요청'));
  }
};

// 작업중지 알림 처리
export const handleWorkStopNotification = (
  dispatch,
  title,
  body,
  responseData,
  Search3
) => {
  if (body?.includes('작업 중지를 요청') || title === '작업중지') {
    if (responseData) {
      dispatch(WorkingCheckActions.setStopWorking(1));
      dispatch(WorkingCheckActions.setWorkStopCd(responseData));
      Search3({ workStopCd: responseData });
    } else {
      dispatch(
        showSnackbar({
          message: '⚠️ 작업중지 알림은 받았으나 작업중지 코드가 없습니다.',
          type: 'warning',
        })
      );
      dispatch(WorkingCheckActions.setStopWorking(1));
    }
  }
};

// 로컬 알림 스케줄
export const scheduleLocalNotification = async (title, body) => {
  try {
    await LocalNotifications.schedule({
      notifications: [
        {
          title: title || '알림',
          body: body || '새로운 알림이 도착했습니다.',
          id: Math.floor(Math.random() * 1000000),
          schedule: { at: new Date(Date.now() + 100) },
        },
      ],
    });
  } catch (err) {
    console.error('🔕 LocalNotification Error:', err);
  }
};
